if (!customElements.get('nv-transform-grid-slider')) {
  customElements.define(
    'nv-transform-grid-slider',
    class TransformGridSlider extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      
      init() {
        // Get logo and header icon positions
        const logo = document.querySelector('.custom-tagline-logo-wrapper');
        const headerIcons = document.querySelector('.desktop-header-icon');
        
        // Calculate offset to align first slide with logo (only for screens >= 991px)
        const calculateOffset = () => {
          if (window.innerWidth > 991 && logo) {
            const logoRect = logo.getBoundingClientRect();
            const sliderRect = this.getBoundingClientRect();
            return logoRect.left - sliderRect.left;
          }
          return 0;
        };
        
        this.swiper = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: this.dataset.mobile || 1,
          loop: false,
          spaceBetween: parseInt(this.dataset.space) || 20,
          centeredSlides: false,
          initialSlide: 0,
          
          // Add offset to start from logo position
          slidesOffsetBefore: calculateOffset(),
          
          // Calculate offset to end at header icons (only for screens >= 991px)
          slidesOffsetAfter: () => {
            if (window.innerWidth > 991 && headerIcons) {
              const iconsRect = headerIcons.getBoundingClientRect();
              const sliderRect = this.getBoundingClientRect();
              const sliderRight = sliderRect.right;
              return Math.max(0, sliderRight - iconsRect.right);
            }
            return 0;
          },
          
          navigation: {
            nextEl: this.querySelector(".nv-grid-slider-next"),
            prevEl: this.querySelector(".nv-grid-slider-prev"),
          },
          
          breakpoints: {
            768: {
              slidesPerView: this.dataset.tablet || 2,
              spaceBetween: parseInt(this.dataset.space) || 20,
              slidesOffsetBefore: calculateOffset(),
            },
            1024: {
              slidesPerView: this.dataset.desktop || 3,
              spaceBetween: parseInt(this.dataset.space) || 20,
              slidesOffsetBefore: calculateOffset(),
            }
          },
          
          on: {
            init: function() {
              // Recalculate on window resize
              window.addEventListener('resize', () => {
                this.params.slidesOffsetBefore = calculateOffset();
                this.update();
              });
            }
          }
        });
      }
    }
  );
}